import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _50f77ce3 = () => interopDefault(import('../../../pages/carriers.vue' /* webpackChunkName: "pages/carriers" */))
const _e3aea8f8 = () => interopDefault(import('../../../pages/comingSoon.vue' /* webpackChunkName: "pages/comingSoon" */))
const _45479ddc = () => interopDefault(import('../../../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _fd13926c = () => interopDefault(import('../../../pages/dashboard-updated.vue' /* webpackChunkName: "pages/dashboard-updated" */))
const _2613651a = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _60f5c8dc = () => interopDefault(import('../../../pages/unauthorized.vue' /* webpackChunkName: "pages/unauthorized" */))
const _3f8c8b99 = () => interopDefault(import('../../../pages/unsubscribe.vue' /* webpackChunkName: "pages/unsubscribe" */))
const _c50bc790 = () => interopDefault(import('../../../pages/about/internetTradingPolicy.vue' /* webpackChunkName: "pages/about/internetTradingPolicy" */))
const _fe862cb6 = () => interopDefault(import('../../../pages/about/loadsure.vue' /* webpackChunkName: "pages/about/loadsure" */))
const _f76c25b0 = () => interopDefault(import('../../../pages/annualCargo/request/index.vue' /* webpackChunkName: "pages/annualCargo/request/index" */))
const _c31ea3a4 = () => interopDefault(import('../../../pages/certificates/bulkUpload.vue' /* webpackChunkName: "pages/certificates/bulkUpload" */))
const _902f3fca = () => interopDefault(import('../../../pages/certificates/buy.vue' /* webpackChunkName: "pages/certificates/buy" */))
const _908c815e = () => interopDefault(import('../../../pages/certificates/buyQuote.vue' /* webpackChunkName: "pages/certificates/buyQuote" */))
const _7c876152 = () => interopDefault(import('../../../pages/certificates/details.vue' /* webpackChunkName: "pages/certificates/details" */))
const _59f08174 = () => interopDefault(import('../../../pages/certificates/find.vue' /* webpackChunkName: "pages/certificates/find" */))
const _85b78ad6 = () => interopDefault(import('../../../pages/certificates/selectPolicyHolder.vue' /* webpackChunkName: "pages/certificates/selectPolicyHolder" */))
const _689e78ff = () => interopDefault(import('../../../pages/claims/annual.vue' /* webpackChunkName: "pages/claims/annual" */))
const _576e8092 = () => interopDefault(import('../../../pages/claims/drafts.vue' /* webpackChunkName: "pages/claims/drafts" */))
const _f96e6fc8 = () => interopDefault(import('../../../pages/claims/file.vue' /* webpackChunkName: "pages/claims/file" */))
const _f2b73c4e = () => interopDefault(import('../../../pages/claims/find.vue' /* webpackChunkName: "pages/claims/find" */))
const _53e87956 = () => interopDefault(import('../../../pages/claims/listFilter.vue' /* webpackChunkName: "pages/claims/listFilter" */))
const _13315e76 = () => interopDefault(import('../../../pages/claims/view.vue' /* webpackChunkName: "pages/claims/view" */))
const _a6676aa0 = () => interopDefault(import('../../../pages/insureLoad/certificate.vue' /* webpackChunkName: "pages/insureLoad/certificate" */))
const _704dcdd1 = () => interopDefault(import('../../../pages/insureLoad/directBuyV1.vue' /* webpackChunkName: "pages/insureLoad/directBuyV1" */))
const _06d6ccb4 = () => interopDefault(import('../../../pages/insureLoad/userSetupV1.vue' /* webpackChunkName: "pages/insureLoad/userSetupV1" */))
const _fc80981a = () => interopDefault(import('../../../pages/insureLoad/v2.vue' /* webpackChunkName: "pages/insureLoad/v2" */))
const _be3e32fc = () => interopDefault(import('../../../pages/integration/apiDocs.vue' /* webpackChunkName: "pages/integration/apiDocs" */))
const _05f6ff8c = () => interopDefault(import('../../../pages/integration/appendix.vue' /* webpackChunkName: "pages/integration/appendix" */))
const _152a85ce = () => interopDefault(import('../../../pages/integration/styleGuide.vue' /* webpackChunkName: "pages/integration/styleGuide" */))
const _1aeb7bb5 = () => interopDefault(import('../../../pages/partner/invoices.vue' /* webpackChunkName: "pages/partner/invoices" */))
const _720efb61 = () => interopDefault(import('../../../pages/partner/masterPolicies.vue' /* webpackChunkName: "pages/partner/masterPolicies" */))
const _71e32e72 = () => interopDefault(import('../../../pages/partner/settings.vue' /* webpackChunkName: "pages/partner/settings" */))
const _24a8d6c9 = () => interopDefault(import('../../../pages/partner/users.vue' /* webpackChunkName: "pages/partner/users" */))
const _2f1d41cc = () => interopDefault(import('../../../pages/payment/payfabric.vue' /* webpackChunkName: "pages/payment/payfabric" */))
const _bda9f6a4 = () => interopDefault(import('../../../pages/portal/settings.vue' /* webpackChunkName: "pages/portal/settings" */))
const _c221ebe6 = () => interopDefault(import('../../../pages/portal/users.vue' /* webpackChunkName: "pages/portal/users" */))
const _d8d22adc = () => interopDefault(import('../../../pages/quotes/details.vue' /* webpackChunkName: "pages/quotes/details" */))
const _bcdaa874 = () => interopDefault(import('../../../pages/underwriter/details.vue' /* webpackChunkName: "pages/underwriter/details" */))
const _3d82d3ca = () => interopDefault(import('../../../pages/underwriter/list.vue' /* webpackChunkName: "pages/underwriter/list" */))
const _5ba68184 = () => interopDefault(import('../../../pages/integration/urlLink/playground.vue' /* webpackChunkName: "pages/integration/urlLink/playground" */))
const _263d0e7c = () => interopDefault(import('../../../pages/underwriter/annualCargo/list.vue' /* webpackChunkName: "pages/underwriter/annualCargo/list" */))
const _fea54102 = () => interopDefault(import('../../../pages/underwriter/annualCargo/details/_id.vue' /* webpackChunkName: "pages/underwriter/annualCargo/details/_id" */))
const _30eeaaf1 = () => interopDefault(import('../../../pages/admin/licensing/_id.vue' /* webpackChunkName: "pages/admin/licensing/_id" */))
const _19d2b34c = () => interopDefault(import('../../../pages/admin/supportData/_id.vue' /* webpackChunkName: "pages/admin/supportData/_id" */))
const _3a21de68 = () => interopDefault(import('../../../pages/admin/taxes/_id.vue' /* webpackChunkName: "pages/admin/taxes/_id" */))
const _8d94937a = () => interopDefault(import('../../../pages/annualCargo/details/_id.vue' /* webpackChunkName: "pages/annualCargo/details/_id" */))
const _9cd15c06 = () => interopDefault(import('../../../pages/annualCargo/list/_tab.vue' /* webpackChunkName: "pages/annualCargo/list/_tab" */))
const _60411990 = () => interopDefault(import('../../../pages/annualCargo/request/_id.vue' /* webpackChunkName: "pages/annualCargo/request/_id" */))
const _23998c70 = () => interopDefault(import('../../../pages/certificates/edit/_id.vue' /* webpackChunkName: "pages/certificates/edit/_id" */))
const _101678fc = () => interopDefault(import('../../../pages/certificates/list/_tab.vue' /* webpackChunkName: "pages/certificates/list/_tab" */))
const _62a6a339 = () => interopDefault(import('../../../pages/contacts/edit/_id.vue' /* webpackChunkName: "pages/contacts/edit/_id" */))
const _54919d12 = () => interopDefault(import('../../../pages/quotes/list/_tab.vue' /* webpackChunkName: "pages/quotes/list/_tab" */))
const _dfafa778 = () => interopDefault(import('../../../pages/users/edit/_id.vue' /* webpackChunkName: "pages/users/edit/_id" */))
const _355bd3a8 = () => interopDefault(import('../../../pages/users/list/_tab.vue' /* webpackChunkName: "pages/users/list/_tab" */))
const _30e3a8e6 = () => interopDefault(import('../../../pages/contacts/_id.vue' /* webpackChunkName: "pages/contacts/_id" */))
const _3001a584 = () => interopDefault(import('../../../pages/partners/_id.vue' /* webpackChunkName: "pages/partners/_id" */))
const _aff294d8 = () => interopDefault(import('../../../pages/partners/_partnerId/users/_id.vue' /* webpackChunkName: "pages/partners/_partnerId/users/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/carriers",
    component: _50f77ce3,
    name: "carriers___en"
  }, {
    path: "/comingSoon",
    component: _e3aea8f8,
    name: "comingSoon___en"
  }, {
    path: "/dashboard",
    component: _45479ddc,
    name: "dashboard___en"
  }, {
    path: "/dashboard-updated",
    component: _fd13926c,
    name: "dashboard-updated___en"
  }, {
    path: "/es",
    component: _2613651a,
    name: "index___es"
  }, {
    path: "/unauthorized",
    component: _60f5c8dc,
    name: "unauthorized___en"
  }, {
    path: "/unsubscribe",
    component: _3f8c8b99,
    name: "unsubscribe___en"
  }, {
    path: "/about/internetTradingPolicy",
    component: _c50bc790,
    name: "about-internetTradingPolicy___en"
  }, {
    path: "/about/loadsure",
    component: _fe862cb6,
    name: "about-loadsure___en"
  }, {
    path: "/annualCargo/request",
    component: _f76c25b0,
    name: "annualCargo-request___en"
  }, {
    path: "/certificates/bulkUpload",
    component: _c31ea3a4,
    name: "certificates-bulkUpload___en"
  }, {
    path: "/certificates/buy",
    component: _902f3fca,
    name: "certificates-buy___en"
  }, {
    path: "/certificates/buyQuote",
    component: _908c815e,
    name: "certificates-buyQuote___en"
  }, {
    path: "/certificates/details",
    component: _7c876152,
    name: "certificates-details___en"
  }, {
    path: "/certificates/find",
    component: _59f08174,
    name: "certificates-find___en"
  }, {
    path: "/certificates/selectPolicyHolder",
    component: _85b78ad6,
    name: "certificates-selectPolicyHolder___en"
  }, {
    path: "/claims/annual",
    component: _689e78ff,
    name: "claims-annual___en"
  }, {
    path: "/claims/drafts",
    component: _576e8092,
    name: "claims-drafts___en"
  }, {
    path: "/claims/file",
    component: _f96e6fc8,
    name: "claims-file___en"
  }, {
    path: "/claims/find",
    component: _f2b73c4e,
    name: "claims-find___en"
  }, {
    path: "/claims/listFilter",
    component: _53e87956,
    name: "claims-listFilter___en"
  }, {
    path: "/claims/view",
    component: _13315e76,
    name: "claims-view___en"
  }, {
    path: "/es/carriers",
    component: _50f77ce3,
    name: "carriers___es"
  }, {
    path: "/es/comingSoon",
    component: _e3aea8f8,
    name: "comingSoon___es"
  }, {
    path: "/es/dashboard",
    component: _45479ddc,
    name: "dashboard___es"
  }, {
    path: "/es/dashboard-updated",
    component: _fd13926c,
    name: "dashboard-updated___es"
  }, {
    path: "/es/unauthorized",
    component: _60f5c8dc,
    name: "unauthorized___es"
  }, {
    path: "/es/unsubscribe",
    component: _3f8c8b99,
    name: "unsubscribe___es"
  }, {
    path: "/insureLoad/certificate",
    component: _a6676aa0,
    name: "insureLoad-certificate___en"
  }, {
    path: "/insureLoad/directBuyV1",
    component: _704dcdd1,
    name: "insureLoad-directBuyV1___en"
  }, {
    path: "/insureLoad/userSetupV1",
    component: _06d6ccb4,
    name: "insureLoad-userSetupV1___en"
  }, {
    path: "/insureLoad/v2",
    component: _fc80981a,
    name: "insureLoad-v2___en"
  }, {
    path: "/integration/apiDocs",
    component: _be3e32fc,
    name: "integration-apiDocs___en"
  }, {
    path: "/integration/appendix",
    component: _05f6ff8c,
    name: "integration-appendix___en"
  }, {
    path: "/integration/styleGuide",
    component: _152a85ce,
    name: "integration-styleGuide___en"
  }, {
    path: "/partner/invoices",
    component: _1aeb7bb5,
    name: "partner-invoices___en"
  }, {
    path: "/partner/masterPolicies",
    component: _720efb61,
    name: "partner-masterPolicies___en"
  }, {
    path: "/partner/settings",
    component: _71e32e72,
    name: "partner-settings___en"
  }, {
    path: "/partner/users",
    component: _24a8d6c9,
    name: "partner-users___en"
  }, {
    path: "/payment/payfabric",
    component: _2f1d41cc,
    name: "payment-payfabric___en"
  }, {
    path: "/portal/settings",
    component: _bda9f6a4,
    name: "portal-settings___en"
  }, {
    path: "/portal/users",
    component: _c221ebe6,
    name: "portal-users___en"
  }, {
    path: "/quotes/details",
    component: _d8d22adc,
    name: "quotes-details___en"
  }, {
    path: "/underwriter/details",
    component: _bcdaa874,
    name: "underwriter-details___en"
  }, {
    path: "/underwriter/list",
    component: _3d82d3ca,
    name: "underwriter-list___en"
  }, {
    path: "/es/about/internetTradingPolicy",
    component: _c50bc790,
    name: "about-internetTradingPolicy___es"
  }, {
    path: "/es/about/loadsure",
    component: _fe862cb6,
    name: "about-loadsure___es"
  }, {
    path: "/es/annualCargo/request",
    component: _f76c25b0,
    name: "annualCargo-request___es"
  }, {
    path: "/es/certificates/bulkUpload",
    component: _c31ea3a4,
    name: "certificates-bulkUpload___es"
  }, {
    path: "/es/certificates/buy",
    component: _902f3fca,
    name: "certificates-buy___es"
  }, {
    path: "/es/certificates/buyQuote",
    component: _908c815e,
    name: "certificates-buyQuote___es"
  }, {
    path: "/es/certificates/details",
    component: _7c876152,
    name: "certificates-details___es"
  }, {
    path: "/es/certificates/find",
    component: _59f08174,
    name: "certificates-find___es"
  }, {
    path: "/es/certificates/selectPolicyHolder",
    component: _85b78ad6,
    name: "certificates-selectPolicyHolder___es"
  }, {
    path: "/es/claims/annual",
    component: _689e78ff,
    name: "claims-annual___es"
  }, {
    path: "/es/claims/drafts",
    component: _576e8092,
    name: "claims-drafts___es"
  }, {
    path: "/es/claims/file",
    component: _f96e6fc8,
    name: "claims-file___es"
  }, {
    path: "/es/claims/find",
    component: _f2b73c4e,
    name: "claims-find___es"
  }, {
    path: "/es/claims/listFilter",
    component: _53e87956,
    name: "claims-listFilter___es"
  }, {
    path: "/es/claims/view",
    component: _13315e76,
    name: "claims-view___es"
  }, {
    path: "/es/insureLoad/certificate",
    component: _a6676aa0,
    name: "insureLoad-certificate___es"
  }, {
    path: "/es/insureLoad/directBuyV1",
    component: _704dcdd1,
    name: "insureLoad-directBuyV1___es"
  }, {
    path: "/es/insureLoad/userSetupV1",
    component: _06d6ccb4,
    name: "insureLoad-userSetupV1___es"
  }, {
    path: "/es/insureLoad/v2",
    component: _fc80981a,
    name: "insureLoad-v2___es"
  }, {
    path: "/es/integration/apiDocs",
    component: _be3e32fc,
    name: "integration-apiDocs___es"
  }, {
    path: "/es/integration/appendix",
    component: _05f6ff8c,
    name: "integration-appendix___es"
  }, {
    path: "/es/integration/styleGuide",
    component: _152a85ce,
    name: "integration-styleGuide___es"
  }, {
    path: "/es/partner/invoices",
    component: _1aeb7bb5,
    name: "partner-invoices___es"
  }, {
    path: "/es/partner/masterPolicies",
    component: _720efb61,
    name: "partner-masterPolicies___es"
  }, {
    path: "/es/partner/settings",
    component: _71e32e72,
    name: "partner-settings___es"
  }, {
    path: "/es/partner/users",
    component: _24a8d6c9,
    name: "partner-users___es"
  }, {
    path: "/es/payment/payfabric",
    component: _2f1d41cc,
    name: "payment-payfabric___es"
  }, {
    path: "/es/portal/settings",
    component: _bda9f6a4,
    name: "portal-settings___es"
  }, {
    path: "/es/portal/users",
    component: _c221ebe6,
    name: "portal-users___es"
  }, {
    path: "/es/quotes/details",
    component: _d8d22adc,
    name: "quotes-details___es"
  }, {
    path: "/es/underwriter/details",
    component: _bcdaa874,
    name: "underwriter-details___es"
  }, {
    path: "/es/underwriter/list",
    component: _3d82d3ca,
    name: "underwriter-list___es"
  }, {
    path: "/integration/urlLink/playground",
    component: _5ba68184,
    name: "integration-urlLink-playground___en"
  }, {
    path: "/underwriter/annualCargo/list",
    component: _263d0e7c,
    name: "underwriter-annualCargo-list___en"
  }, {
    path: "/es/integration/urlLink/playground",
    component: _5ba68184,
    name: "integration-urlLink-playground___es"
  }, {
    path: "/es/underwriter/annualCargo/list",
    component: _263d0e7c,
    name: "underwriter-annualCargo-list___es"
  }, {
    path: "/",
    component: _2613651a,
    name: "index___en"
  }, {
    path: "/es/underwriter/annualCargo/details/:id?",
    component: _fea54102,
    name: "underwriter-annualCargo-details-id___es"
  }, {
    path: "/es/admin/licensing/:id?",
    component: _30eeaaf1,
    name: "admin-licensing-id___es"
  }, {
    path: "/es/admin/supportData/:id?",
    component: _19d2b34c,
    name: "admin-supportData-id___es"
  }, {
    path: "/es/admin/taxes/:id?",
    component: _3a21de68,
    name: "admin-taxes-id___es"
  }, {
    path: "/es/annualCargo/details/:id?",
    component: _8d94937a,
    name: "annualCargo-details-id___es"
  }, {
    path: "/es/annualCargo/list/:tab?",
    component: _9cd15c06,
    name: "annualCargo-list-tab___es"
  }, {
    path: "/es/annualCargo/request/:id",
    component: _60411990,
    name: "annualCargo-request-id___es"
  }, {
    path: "/es/certificates/edit/:id?",
    component: _23998c70,
    name: "certificates-edit-id___es"
  }, {
    path: "/es/certificates/list/:tab?",
    component: _101678fc,
    name: "certificates-list-tab___es"
  }, {
    path: "/es/contacts/edit/:id?",
    component: _62a6a339,
    name: "contacts-edit-id___es"
  }, {
    path: "/es/quotes/list/:tab?",
    component: _54919d12,
    name: "quotes-list-tab___es"
  }, {
    path: "/es/users/edit/:id?",
    component: _dfafa778,
    name: "users-edit-id___es"
  }, {
    path: "/es/users/list/:tab?",
    component: _355bd3a8,
    name: "users-list-tab___es"
  }, {
    path: "/underwriter/annualCargo/details/:id?",
    component: _fea54102,
    name: "underwriter-annualCargo-details-id___en"
  }, {
    path: "/admin/licensing/:id?",
    component: _30eeaaf1,
    name: "admin-licensing-id___en"
  }, {
    path: "/admin/supportData/:id?",
    component: _19d2b34c,
    name: "admin-supportData-id___en"
  }, {
    path: "/admin/taxes/:id?",
    component: _3a21de68,
    name: "admin-taxes-id___en"
  }, {
    path: "/annualCargo/details/:id?",
    component: _8d94937a,
    name: "annualCargo-details-id___en"
  }, {
    path: "/annualCargo/list/:tab?",
    component: _9cd15c06,
    name: "annualCargo-list-tab___en"
  }, {
    path: "/annualCargo/request/:id",
    component: _60411990,
    name: "annualCargo-request-id___en"
  }, {
    path: "/certificates/edit/:id?",
    component: _23998c70,
    name: "certificates-edit-id___en"
  }, {
    path: "/certificates/list/:tab?",
    component: _101678fc,
    name: "certificates-list-tab___en"
  }, {
    path: "/contacts/edit/:id?",
    component: _62a6a339,
    name: "contacts-edit-id___en"
  }, {
    path: "/es/contacts/:id?",
    component: _30e3a8e6,
    name: "contacts-id___es"
  }, {
    path: "/es/partners/:id?",
    component: _3001a584,
    name: "partners-id___es"
  }, {
    path: "/quotes/list/:tab?",
    component: _54919d12,
    name: "quotes-list-tab___en"
  }, {
    path: "/users/edit/:id?",
    component: _dfafa778,
    name: "users-edit-id___en"
  }, {
    path: "/users/list/:tab?",
    component: _355bd3a8,
    name: "users-list-tab___en"
  }, {
    path: "/es/partners/:partnerId?/users/:id?",
    component: _aff294d8,
    name: "partners-partnerId-users-id___es"
  }, {
    path: "/contacts/:id?",
    component: _30e3a8e6,
    name: "contacts-id___en"
  }, {
    path: "/partners/:id?",
    component: _3001a584,
    name: "partners-id___en"
  }, {
    path: "/partners/:partnerId?/users/:id?",
    component: _aff294d8,
    name: "partners-partnerId-users-id___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
